const CTComponents = require.context('./', true, /\main.js$/)
const ctComs = () => {
  CTComponents.keys().map(com => {
    CTComponents(com).default()
  })
}
export default ctComs
